
<div v-if="open" class="conflict-banner v-flex">
    <v-icon color="error" size="22" class="mr-2">mdi-alert-octagon-outline</v-icon>

    <div class="conflict-text">
        <div class="font-weight-medium">
            {{ $t('disposition.inspection.deviceType.conflict.title') }}
        </div>
        <div>{{ text }}</div>
        <div class="conflict-hint">
            {{ $t('disposition.inspection.deviceType.conflict.hint') }}
        </div>
    </div>

    <v-spacer />

    <div class="v-flex conflict-actions">
        <v-btn
            v-if   = "inspection.unit && inspection.unit.id"
            small
            outlined
            color  = "primary"
            class  = "mr-2"
            @click = "$emit('unit', inspection.unit)"
        >
            {{ $t('disposition.inspection.deviceType.conflict.unit') }}
        </v-btn>
        <v-btn
            small
            color    = "primary"
            :loading = "checking"
            @click   = "$emit('check')"
        >
            {{ $t('disposition.inspection.deviceType.conflict.check') }}
        </v-btn>
    </div>
</div>
